<template>
	<div id='editorialRules'>
		<el-dialog 
        title="编辑规则" 
        :visible.sync='isShow' 
        width="800px"
		@open = "handleClear"
        :before-close = 'handleClose_HD'
        class='default-dialog'
        >
	        <el-form inline>
	        	<el-form-item label="项目名称：">
					<el-input v-model='batchFormulaVo.fin.name' size='mini' placeholder='请输入项目名称' style='width:200px' @input="handleInput"></el-input>
				</el-form-item>
	        	<el-form-item label="取数规则：">
					<el-select v-model="form.ruleOfFetch" style='width:120px'  size="mini">
						<el-option
							v-for="item in options.regulation"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="运算符号：" v-if = "isShowOther">
					<el-select v-model="form.operationalSymbol" size="mini" style='width:60px'>
						<el-option
							v-for="item in options.symbol"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="科目名称：" v-if = "isShowOther">
					<el-select v-model="form.subjectId" size="mini" filterable placeholder="请选择" style='width:200px'>
						<el-option
							v-for="item in options.objestData"
							:key="item.id"
							:label="item.labels"
							:value="item.id">						
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间类型：" v-if = "isShowOther">
					<el-select v-model="form.timeType"  style='width:120px' size="mini">
						<el-option
							v-for="item in options.timeTypeList"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item >
					<el-button class='minButton' size='mini' @click='handleAddRule'>添加</el-button>
				</el-form-item>
	        </el-form>
	        <public-table :table="tableData"  @onHandleoperate="handleOperation" v-if = "isShowOther">
			
			</public-table>
			<div class='bottom_button' v-if = "isShowOther">
				<el-button class='minButton' size='small' @click='handleSavelot'>保存</el-button>
			</div>
	    </el-dialog>
	</div>
</template>

<script>
import publicTable from '@/components/publicTable' 

export default {
	props: {
		showVisible: Boolean,
		row: Object
	},
	components: {
		publicTable
	},
	data () {
		return {
			isShowOther: true,  // 是否显示其他选项
			superValue:false,    // 控制关闭回调
			form: {
				subjectId: '',   // 科目ID
				timeType: '',    // 时间类型
				ruleOfFetch: '', // 取数规则
				operationalSymbol:'+', // 运算符号
				financialSettingId: '', // 财务状况ID

			},
			batchFormulaVo:{
				list: [],
				fin: {
					name: '',
					id: '',
				}
			},     // 所有发送请求数据
			tableData: {
				isNotSuspensionShow: true,  // 不显示悬浮效果
				Maxheight: 400,				// 限定高度 
				border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,				// 是否显示加载动画
				hasSelect: false,			// 是否显示多选
				hasOperation: true,		// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				hasShowPagination: false,	// 是否显示分页
				config: [{
					label: '科目',
					value: 'subName',
					show: 'normal'
				},{
					label: '运算符号',
					value: 'operationalSymbol',
					width: 80,
					show: 'normal'
				},{
					label: '取数规则',
					value: 'ruleOfFetch',
					show: 'normal',
					formatter: this.formatter
				},{
					label: '时间类型',
					value: 'timeType',
					show: 'normal',
					formatter: this.formatter
				}],
				data: [],
				operation: {
					label: '操作',
					value: 'operation',
					data: [{
						label: '删除',
						value: 'delete'
					}]
				},
				page: {
					pageNo: 1,
					pageSize: 20,
					count: 10
				},
				center: {
					textAlign: 'center'
				}
			},
			options: {
				symbol: [{
					value: '+',
					label: '+'
				},{
					value: '-',
					label: '-'
				}],
				regulation: [],
				objestData: [],
				timeTypeList:[],
			},
		}
	},
	created() {
		
	},
	computed: {
		// 显示弹窗
		isShow: {
			get () {
				return this.showVisible;
			},
			set (val) {
				this.$emit('update:showVisible', val);
			}
		},
	},
	methods: {
		// 清空数据
		handleClear() {
			this.batchFormulaVo.fin.name = "";
			this.isShowOther = true;
		},
		// 监听名称输入
		handleInput(val) {
			if(val == "预估所得税") {
				this.isShowOther = false;
			}else {
				this.isShowOther = true;
			}
		},
		// 关闭弹框回调
		handleClose_HD(){
			if(this.superValue) {
				this.$confirm('系统检测到您做了操作，但是没有保存，点击确认将会放弃保存您添加/删除的公式，是否继续?', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          type: 'warning'
			        }).then(()=>{
			        	if(!this.row.id) {
			        		this.tableData.data = [];
			        	}else {
			        		this.getTableList(this.row.id);
			        	}
			        	this.isShow = false;
			        	this.superValue = false;
			        }).catch(()=>{
			        	this.$message.warning('已为您取消操作，您可以继续编辑公式！')
			        })
			}else {
				this.superValue = false;
				this.isShow = false;
				if(!this.row.id) {
	        		this.tableData.data = [];
	        	}
			}
		},
		// 格式化
		formatter(row, column, cellValue, index) {
			switch (column.property) {
				case 'ruleOfFetch':
					switch (row[column.property]) {
						case '1':
							return '余额'
							break;
						case '2':
							return '借方发生额'
							break;
						case '3':
							return '贷方发生额'
							break;
						case '5':
							return '损益发生额'
							break;
						case '8':
							return '负数余额取正'
							break;
						default:
							return row[column.property];
							break;
					}
					break;
				case 'timeType':
					switch (row[column.property]) {
						case '1':
							return '本期'
							break;
						case '2':
							return '本年'
							break;
						case '3':
							return '年初'
							break;
						default:
							return row[column.property];
							break;
					}
					break;
			}
		},
		// 查询所有科目
		getAllSubject () {
			this.$http.post('subject/getAllSujectByContent' , {}).then(res=>{
				if(res && res.data.code==1) {
					this.options.objestData = res.data.data;
					if(res.data.data.length) {
						this.form.subjectId = res.data.data[0].id;
					}
					if(this.options.objestData.length) {
						this.options.objestData.forEach(i=>{
							i.labels = i.code+'_'+i.name;
						})
					}

					
				}
			})
		},
		//表格操作按钮
		handleOperation(data){
			const {methods,row} = data;
			switch (methods) {
				case 'delete':
					this.deleteMethods(row);
					break;
			}
		},
		//删除列表数据方法
		deleteMethods(row){
			if(this.tableData.data.length) {
				this.tableData.data.splice(row.rowIndex , 1)
				this.tableData.data.forEach((item,index)=>{
					item.rowIndex = index;
				})
			}
			
		},
		// 批量保存
		handleSavelot() {
			if(!this.tableData.data.length) {
				return this.$message.warning('编辑规则表格不能为空哦！')
			}
			this.batchFormulaVo.list = this.tableData.data;
			try {
				this.tableData.loading = true;
				this.$http.post('financialSetting/batchSave',this.batchFormulaVo).then(res=>{
					this.tableData.loading = false;
					if(res && res.data.code == 1) {
						this.superValue = false;
						this.$message.success(res.data.msg)
						this.isShow = false;
						this.$emit('handleAddSuccessMessage' , true);
					}
				})
			}catch(e) {
				this.tableData.loading = false;
			}
		},
		// 添加规则
		handleAddRule() {
			let subName = this.options.objestData.find(i=>{return i.id == this.form.subjectId});
			let pice = {
				id: '',
				operationalSymbol: this.form.operationalSymbol,
				ruleOfFetch: this.form.ruleOfFetch,
				subName: subName.labels,
				timeType: this.form.timeType,
				subjectId: this.form.subjectId,
			}
			this.tableData.data.push(pice);
			if(this.tableData.data.length) {
				this.tableData.data.forEach((item,index)=>{
					item.rowIndex = index;
				})
			}
			if(!this.isShowOther) {
				pice.subjectId = "";
				this.handleSavelot();
				return;
			}
			this.superValue = true;
		},
		// 获取取数规则
		getRules() {
			this.$http.post('sys/dict/list' , {type: 'rule'}).then(res=>{
				if(res && res.data.code == 1) {
					this.options.regulation = res.data.data;
					this.form.ruleOfFetch = res.data.data[0].value;

				}
			})
		},
		// 获取时间类型
		getTimeType() {
			this.$http.post('sys/dict/list' , {type: 'time_type'}).then(res=>{
				if(res && res.data.code == 1) {
					this.options.timeTypeList = res.data.data;
					this.form.timeType = res.data.data[0].value;

				}
			})
		},
		// 获取表格数据
		getTableList(id) {
			try {
				this.tableData.loading = true;
				this.$http.post('financialSetting/getFormulaByFinId' , {finId: id}).then(res=>{
					this.tableData.loading = false;
					if(res && res.data.code == 1) {
						this.tableData.data = res.data.data;
						this.superValue = false;
						if(this.tableData.data.length) {
							this.tableData.data.forEach((item,index)=>{
								item.rowIndex = index;
							})
						}
					}
				})
			}catch(e) {
				this.tableData.loading = false;
			}
		},
	},
	watch: {
		'row.id'(val) {
			if(val) {
				this.getTableList(val)
				this.getAllSubject();
				this.getRules();
				this.getTimeType();
				this.batchFormulaVo.fin.name = this.row.name;
				this.batchFormulaVo.fin.id = this.row.id;
			}else {
				this.batchFormulaVo.fin.name = '';
				this.batchFormulaVo.fin.id = '';
				this.getAllSubject();
				this.getRules();
				this.getTimeType();
				this.superValue = false;
				this.tableData.data = [];
			}
		}
	}
}
</script>
<style lang='less' >
	#editorialRules {
		.bottom_button {
			text-align: right;
			padding-top: 40px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/dialog/editorialRules.vue